var React = require('react');

function PlanetaSmall (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#FFFFFF","d":"M15,0h34c8.3,0,15,6.7,15,15v34c0,8.3-6.7,15-15,15H15C6.7,64,0,57.3,0,49V15C0,6.7,6.7,0,15,0z\n\t","key":0}),React.createElement("path",{"fill":"#11133D","d":"M28.2,52C19.2,52,12,44.8,12,35.9s7.2-16.1,16.2-16.1S44.3,27,44.3,35.9S37.1,52,28.2,52z\n\t M48.4,23.1c-3.1,0-5.6-2.5-5.6-5.5s2.5-5.5,5.6-5.5s5.6,2.5,5.6,5.5S51.5,23.1,48.4,23.1z","key":1})]);
}

PlanetaSmall.defaultProps = {"width":"64px","height":"64px","viewBox":"0 0 64 64"};

module.exports = PlanetaSmall;

PlanetaSmall.default = PlanetaSmall;
